import { render, staticRenderFns } from "./ViewPartnerCompany.vue?vue&type=template&id=23af505d&scoped=true&"
import script from "./ViewPartnerCompany.vue?vue&type=script&lang=js&"
export * from "./ViewPartnerCompany.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23af505d",
  null
  
)

export default component.exports